import { mapState, mapActions } from 'vuex'
import { NAMESPACE, KANBAN } from '../store'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE as APP_NAMESPACE } from '@argon/app/store'
import BoardMixin from './BoardMixin'

export default {
  name: 'KanbanMixin',
  mixins: [BoardMixin],
  props: {
    orgRef: String,
    boardRef: {
      type: [String, Number],
      required: true
    }
  },
  data: () => ({
    height: 0,
    counts: 'comments,documents,reminders,tags,todos,tasks',
    include: '',
    searchFields: [{ label: 'display', type: 'text' }]
  }),
  computed: {
    ...mapState(BOARD_NAMESPACE, ['board', 'columns']),
    ...mapState(APP_NAMESPACE, ['appliedFilters']),
    context() {
      return this.boardRef
    },
    filterObject() {
      return this.appliedFilters[this.boardRef]
    },
    filterItems() {
      return this.filterObject ? this.filterObject.items : []
    },
    filterStamp() {
      return this.filterObject ? this.filterObject.stamp : null
    }
  },

  methods: {
    ...mapActions(NAMESPACE, ['setDisplayType']),
    onResize(e) {
      let headerHeight = 240
      this.height = window.innerHeight - headerHeight
    }
  },
  mounted() {
    this.onResize()
  },
  created() {
    this.setDisplayType(KANBAN)
  }
}
